// eslint-disable-next-line no-restricted-imports
import { createQuote } from '@/features/wizard/store';
import type { IGuestUser, IRegisteredUser } from '@/types';
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

interface IUserState {
  user: IGuestUser | IRegisteredUser | undefined;
}

const initialState: IUserState = {
  user: undefined,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    updateUser: (state, action: PayloadAction<IGuestUser | IRegisteredUser>) => {
      state.user = action.payload;
    },
  },
  extraReducers(builder) {
    builder.addCase(createQuote.fulfilled, (state) => {
      state.user = state.user
        ? {
            firstName: '',
            email: state.user.email,
            lastName: '',
            fiscalCode: '',
            id: '',
            password: '',
            phone: '',
            streetAddress: '',
            city: '',
            countryCode: '',
            province: '',
            zipCode: '',
          }
        : (state.user = undefined);
    });
  },
});

export const { updateUser } = userSlice.actions;

export default userSlice.reducer;

// TODO[WIZARD]Refactoring for store and slices scaffolding (see eslint disable error above)
